module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_title_decoration-7fb2aa5be1cf2399062b3db6b7ce96a1.svg";